<template>
  <section class="tarifResaView">

    <section class="avion">
      <img src="@/assets/images/background/Fond-tarifs1.jpg" alt="Foret" class="bg-foret" />
      <div class="tarifsSection">
        <h2 class="titlePage">
          Tarifs et Réservations
        </h2>
        <br>
        <p>
          <span class="black-text">Obtenez un tarif et réservez le gîte en fonction de sa
            disponibilité</span><br />
          <!-- <span>vous avez la possibilité de louer les deux gîtes</span> -->
        </p>
        <div class="tarifsContainer">
          <!-- <div class="itemTarifs">
            <img src="@/assets/images/tarifstudio.jpg" alt="Tarification studio" />
            <a href="/reservations-studio" class="greenBtn">Voir les disponibilités de l'escale</a>
          </div>-->
          <div class="itemTarifs">
            <!-- <img src="@/assets/images/tarifspetitgite.jpg" alt="Tarification gite" />
            <a href="/reservations-petit-gite" class="greenBtn">Voir les disponibilités du petit gite</a> -->
            <p>
              En réservant votre gîte en direct sur notre site, vous bénéficiez du meilleur tarif, d’échanges personnalisés avec les propriétaires et de conseils sur mesure pour organiser votre séjour. Parcourez les photos du gîte, découvrez les activités aux alentours et planifiez dès maintenant vos prochaines vacances au Gîte d’en Lebé.
            </p>
          </div> 
          <div class="itemTarifs">
            <img src="@/assets/images/tarifsgite.jpg" alt="Tarification gite" />
            <a href="/contact" class="greenBtn">Contact</a>
          </div>
        </div>
      </div>
    </section>

    <Extra></Extra>

    <Slideshow sliderheight="450px" :slidewidth="responsiveWidth" rightnav_class="fas fa-angle-right fa-4x"
      leftnav_class="fas fa-angle-left fa-4x" activeclass="activeDiapo">
      <div>
        <img src="@/assets/images/001.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/002.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/003.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/004.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/005.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/006.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/007.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/008.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/009.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/010.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/011.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/013.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/014.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/015.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/016.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/017.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/018.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/019.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/020.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/021.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/022.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/023.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/025.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/026.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/027.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/031.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/032.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/033.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/034.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/035.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/037.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/038.jpg" alt="Gite d'en lebé" />
      </div>
      <div>
        <img src="@/assets/images/042.jpg" alt="Gite d'en lebé" />
      </div>
    </Slideshow>

    <div class="barBottom">
      <div class="navImg">
        <router-link to="/contact">
          <img src="@/assets/icones/map.png" alt="icone carte" />
          <p>
            <strong>Nous trouver</strong>
            <br />
            {{ $store.state.globalData.name }}
            {{ $store.state.globalData.ville }}
          </p>
        </router-link>
        <a href="tel:0625627464">
          <!-- <img src="@/assets/icones/clef.png" alt="icone jeu de clefs" /> -->
          <i class="fab fa-whatsapp"></i>
          <p>
            <strong>Réservation</strong>
            <br />
            {{ $store.state.globalData.bandeauVertTel }}
            <p>(Sms & appels)</p>
          </p>
        </a>
        <a href="mailto:enlebegite@gmail.com">
          <i class="fal fa-envelope fa-2x"></i>
          <p>
            <strong>{{ $store.state.globalData.emailBandeauVert }}</strong>
            <br />
            <!-- {{ $store.state.globalData.telephonePortable }} -->
          </p>
        </a>
      </div>
    </div>
    <button id="scrollToTopButton" style="display: none;"><i class="fas fa-arrow-up"></i></button>
  </section>

</template>

<script>
import Slideshow from "@/components/Slideshow.vue";
import Extra from "@/components/Extra.vue";

export default {
  name: "TarifsResa",
  components: {
    Slideshow,
    Extra
  },
  computed: {
    responsiveWidth: {
      get() {
        let val = window.innerWidth;
        if (val > 1000) {
          return "25";
        } else if (val < 1000 && val > 768) {
          return "50";
        } else return "90";
      },
    },
  },
  mounted() {
    const headerHeight = 190;

    document.querySelectorAll('.summary-item a').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        let target = this.getAttribute('href');
        let targetElement = document.querySelector(target);

        if (targetElement) {
          let targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;

          window.scrollTo({
            top: targetPosition - headerHeight,
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
    $(window).scroll(function () {
      var scrollPosition = $(window).scrollTop();
      console.log(scrollPosition);
      if (scrollPosition > 100) {
        $(".summary").addClass("scrolled");
      } else {
        $(".summary").removeClass("scrolled");
      }
    });
    document.addEventListener('DOMContentLoaded', function () {
      const scrollBtn = document.getElementById('scrollToTopButton');

      // Fonction pour détecter le défilement et afficher/masquer le bouton
      function scrollFunction() {
        if (document.body.scrollTop > window.innerHeight / 2 || document.documentElement.scrollTop > window.innerHeight / 2) {
          scrollBtn.style.display = "block";
        } else {
          scrollBtn.style.display = "none";
        }
      }

      // Écouter l'événement de défilement
      window.onscroll = function () {
        scrollFunction();
      };

      // Fonction pour le retour en haut de la page
      scrollBtn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });

  },
};
</script>
<style scoped>
.black-text {
  color: #000 !important;
}

.icon-view strong {
  font-size: 18px;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: 800;
  color: #111;
}

.img-place>img {
  max-width: 100px;
}

.avion span {
  color: #000 !important;
}

.avion p {
  margin-top: unset;
  position: relative;
}

.tarifsSection {
  justify-content: normal !important;
  position: relative;
  margin-bottom: 100px;
}

.tarifsSection>div {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* Centre les éléments horizontalement */
  max-width: 20%;
  /* Limite la largeur maximale à 50% pour créer deux colonnes */
}

.tarifsSection>div img {
  max-width: 100%;
  /* Limite la taille maximale de l'image à 20% */
}

.tarifsSection {
  display: flex;
  margin-top: 100px;
  justify-content: space-around;
  /* Distribue l'espace autour des éléments pour centrer les colonnes */
}

table {
  width: 100%;
  text-align: center;
  border-spacing: 0;
  margin-bottom: 2rem;
}

tr:nth-child(even) {
  background: #fff;
}

th,
tr:nth-child(odd) {
  background: rgb(228, 236, 218);
}

th,
td {
  padding: 1rem 0;
}

.tarifResaView .imageContainer>*>* {
  /* object-fit: contain;
  background: rgb(228, 236, 218); */
}

.tarifsSection {
  text-align: center;
}

.tarifsSection h2 {
  margin: 0 0 2rem;
}

.tarifResaView .imageContainer>* {
  padding: 5px;
}

.saison span {
  font-size: 13px;
  font-weight: 500;
}

.summary li {
  flex: 1;
  transition: .4s all;
  flex-wrap: wrap;
}

.summary li a {
  transition: .4s all;
  color: white;
}

.summary li:hover a {
  color: #A8BE50;
}

.summary li:hover {
  background-color: white;
  color: #A8BE50;
}

#scrollToTopButton {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  padding: 20px;
  background-color: #A8BE50;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #A8BE50;
  transition: 0.4s;
}

#scrollToTopButton:hover {
  background-color: white;
  border: 1px solid #A8BE50;
}

#scrollToTopButton:hover i {
  color: #A8BE50;
}

.avion {
  position: relative;
  overflow: hidden;
}

.avion div {
  position: relative;
}

.bg-foret {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100%;
  object-fit: cover;
}

.tarifsContainer {
  display: flex !important;
  align-items: flex-start !important;
  justify-content: center;
  flex-direction: row !important;
  max-width: 65% !important;
  gap: 2rem;
  flex-wrap: wrap;
}

.itemTarifs {
  width: 30%;
}

.itemTarifs p {
  text-align: left;
  font-size: 18px;
}

.greenBtn {
  white-space: normal;
}

@media screen and (max-width: 1100px) {
  .itemTarifs {
    width: 47%;
  }
}

@media screen and (max-width: 800px) {
  .itemTarifs {
    width: 90%;
  }

  .bg-foret {
    display: none;
  }

  .avion img {
    height: unset;
  }
}

@media screen and (max-width: 425px) {
  .itemTarifs {
    width: 100%;
  }
}
</style>
